// base
import React from "react";

// components
import { Button } from "..";
import { Link } from "react-router-dom";

// assets
import arrow from "../../assets/images/transactions/arrow.png";
import "./AccountTokenTransaction.scss";
import defaultSymbol from '../../assets/images/common/default_symbol.png';

import { substring, fromNow, getValueByDecimals } from "../../../helper";
import abiDecoder from 'abi-decoder';

const AccountTokenTransaction = ( props ) => {
  const { transactions, address } = props;

  transactions.map(tx => {
    if (tx.abi) {
      abiDecoder.addABI(JSON.parse(tx.abi));
      tx.decodeMethod = abiDecoder.getMethodIDs()[tx.method].name;
      abiDecoder.removeABI(JSON.parse(tx.abi));
    } else {
      tx.decodeMethod = tx.method;
    }

    tx.decodeValue = parseInt(tx.value, 16);
    if (tx.decimals) {
      tx.decodeValue = getValueByDecimals(tx.decodeValue, tx.decimals);
    }

    return tx;
  })

  return (
    <div className='responsive_table'>
      <table className="table_type01 token_txns_table">
        <thead>
          <tr>
            <th>TX HASH</th>
            <th>TIME</th>
            <th>FROM</th>
            <th><img src={arrow} alt="에서" /></th>
            <th>TO</th>
            <th>METHOD</th>
            <th>VALUE</th>
            <th>TOKEN</th>
          </tr>
        </thead>
        <tbody>
          { transactions && transactions.length > 0 &&
            transactions.map((item, index) => (
              <tr key={index}>
                <td>
                  <Button color="blue" size="wide"
                          link={`/transaction/${item.hash}`} tooltip={item.hash}>
                    {substring(item.hash)}
                  </Button>
                </td>
                <td>{fromNow(item.time)}</td>
                <td>
                  {
                    address === item.from &&
                    <Button color="gray" size="wide" disable={true} tooltip={item.from}>
                      {substring(item.from)}
                    </Button>
                  }
                  {
                    address !== item.from &&
                    <Button color="blue" size="wide"
                            link={`/account/${item.from}`} tooltip={item.from}>
                      {substring(item.from)}
                    </Button>
                  }
                </td>
                <td>
                  <img src={arrow} alt="에서" />
                </td>
                <td>
                  {
                    address === item.to &&
                    <Button color="gray" size="wide" disable={true} tooltip={item.to}>
                      {substring(item.to)}
                    </Button>
                  }
                  {
                    address !== item.to &&
                    <Button color="blue" size="wide"
                            link={`/account/${item.to}`} tooltip={item.to}>
                      {substring(item.to)}
                    </Button>
                  }
                </td>
                <td>{item.decodeMethod}</td>
                <td>{item.decodeValue.toLocaleString()}</td>
                <td>
                  {
                    item.token ?
                    <div>
                      <img className="token_icon" alt="icon"
                           src={item.icon ? item.icon : defaultSymbol}
                           onError={e => e.target.src = defaultSymbol} />
                      <Link to={`/contract/${item.tokenAddress}`}>{item.token}</Link>
                    </div>
                    :
                    <Button color="gray" size="wide" disable={true} tooltip={item.tokenAddress}>
                      {substring(item.tokenAddress)}
                    </Button>
                  }
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default AccountTokenTransaction;
